import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatOverlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_overline"}/>
}
